jQuery(document).ready(function ($) {
    $.fn.setToLoading = function () {
        this.attr('disabled', true).addClass('loading').text('Loading...');
        return this;
    }

    $.fn.returnToLoad = function () {
        this.removeAttr('disabled').removeClass('loading').text(this.attr('data-default'));
        return this;
    }

    $.fn.getRooms = function () {
        const ajax_data = {
            page: this.prev().attr('data-page'),
            action: 'get_rooms',
            nonce: rooms.nonce,
        }

        const _this = this;

        $.ajax({
            url: rooms.ajax_url,
            type: 'POST',
            data: ajax_data,

            beforeSend: function () {
                _this.setToLoading();
            },

            success: function (response) {
                _this.prev().attr('data-page', response.data.next_page).append(response.data.rooms);

                if (parseInt(response.data.next_page) === 0) {
                    _this.hide();
                }
            },

            complete: function () {
                _this.returnToLoad();
            }
        });

        return this;
    }

    $('.rooms-archive__load').on('click', function (event) {
        event.preventDefault();

        $(this).getRooms();
    });
});